import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
// import { Outlet } from 'react-router-dom';
// import LeftNav from '../../Components/LeftNavok/LeftNav';
import Head from '../../Components/Head/Head';
import { useTranslation } from 'react-i18next';


const NotFound = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const [userLoggeIn, setUserLoggedIn] = useState(false);

    useEffect(() => {
        
        console.log('in use Effect of Root.js');

        if (localStorage.getItem("userToken"))
        {
            console.log('in use Effect of Root.js if condition');

            setUserLoggedIn(true);
        }
    }, [location.pathname]);

    return (
        <div className="siteContainer">
            <div className="row m-0">
                {/* { userLoggeIn &&  <LeftNav /> } */}
                {/* <div className={`siteRight ${userLoggeIn ? "col-md-9 p-0" : "col-md-12"}`}> */}
                    { userLoggeIn &&  <Head /> }
                    <div className="p-5">
                        <div className='alert alert-danger' style={{textAlign:'center',height:'260px'}}>
                        <h1 className="text-6xl font-bold text-red-600" style={{marginTop:'65px'}}>404</h1>
      <p className="text-2xl mt-4 mb-2">Page Not Found</p>
      <p className="text-gray-600 mb-6">Sorry, the page you are looking for does not exist.</p>
                        </div>
                    </div>
                </div>
            {/* </div> */}
        </div>
    );
}
export default NotFound;